export const FETCH_SYSTEMS_REQUEST = 'PM.FETCH_SYSTEMS_REQUEST';
export const FETCH_SYSTEMS_SUCCESS = 'PM.FETCH_SYSTEMS_SUCCESS';
export const FETCH_SYSTEMS_FAILURE = 'PM.FETCH_SYSTEMS_FAILURE';

export const FETCH_JOBS_REQUEST = 'PM.FETCH_JOBS_REQUEST';
export const FETCH_JOBS_SUCCESS = 'PM.FETCH_JOBS_SUCCESS';
export const FETCH_JOBS_FAILURE = 'PM.FETCH_JOBS_FAILURE';

export const FETCH_SOFTWARE_REQUEST = 'PM.FETCH_SOFTWARE_REQUEST';
export const FETCH_SOFTWARE_SUCCESS = 'PM.FETCH_SOFTWARE_SUCCESS';
export const FETCH_SOFTWARE_FAILURE = 'PM.FETCH_SOFTWARE_FAILURE';

export const FETCH_SYSTEMS_WITH_JOBS_REQUEST = 'PM.FETCH_SYSTEMS_WITH_JOBS_REQUEST';
export const FETCH_SYSTEMS_WITH_JOBS_SUCCESS = 'PM.FETCH_SYSTEMS_WITH_JOBS_SUCCESS';
export const FETCH_SYSTEMS_WITH_JOBS_FAILURE = 'PM.FETCH_SYSTEMS_WITH_JOBS_FAILURE';

export const FETCH_SYSTEMS_WITH_SOFTWARE_REQUEST = 'PM.FETCH_SYSTEMS_WITH_SOFTWARE_REQUEST';
export const FETCH_SYSTEMS_WITH_SOFTWARE_SUCCESS = 'PM.FETCH_SYSTEMS_WITH_SOFTWARE_SUCCESS';
export const FETCH_SYSTEMS_WITH_SOFTWARE_FAILURE = 'PM.FETCH_SYSTEMS_WITH_SOFTWARE_FAILURE';


// WEBPACK FOOTER //
// ./src/constants/PM.ts